module.exports = __webpack_public_path__ + "static/media/tab-bg.12112683.png";